import { t } from 'i18next';
import { getServiceIcon } from '../analytics/ConversationsByService';
import CustomerList from './CustomerList_'
import DashboardWrapper from "components/wrappers/DashboardWrapper"
import PropTypes from 'prop-types';

const Customers = () => {

    return (
        <DashboardWrapper>
            <CustomerList />
        </DashboardWrapper>
    )

}

export default Customers;


export const pickPrivacyStatus = (status) => {
    if (status) {
        return <span className="rounded px-2 py-1 text-green-600   bg-green-100 text-xs">
            {t('actions.accepted')}
        </span>
    } else {
        return <span className="rounded px-2 py-1 text-gray-600 border-gray-200  bg-gray-100 text-xs">
            {t('actions.declined')}
        </span>
    }
}

export const pickServiceStatus = (status) => {
    if (status) {
        return <span className="w-8 font-bold tooltip tooltip-primary rounded p-2  mr-2 text-green-600   bg-green-100  border border-green-100 transition duration-150 ease-in-out"
            data-tip={t('actions.consulted')}
        > ✓
        </span>

    } else {
        return <span className="w-8 font-medium  tooltip tooltip-primary rounded p-2  mr-2 text-gray-600  bg-gray-100  border border-gray-100 transition duration-150 ease-in-out"
            data-tip={t('actions.not_consulted')}
        > X
        </span>
    }


}


export function HeaderServiceTitle({ titleKey }) {
    return (
        <div className="w-8 tooltip tooltip-primary bg-white rounded transition duration-150 ease-in-out p-2  mr-2 border"
            data-tip={t(`analytics.conversations_by_service.${titleKey}.title`)}
        >
            {getServiceIcon(titleKey)}
        </div>
    )
}

HeaderServiceTitle.propTypes = {
    titleKey: PropTypes.string,
};



